var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"text-wrapper"},[_c('legend',{staticClass:"label",style:(_vm.getStyle)},[_vm._v(_vm._s(_vm.element.label[_vm.$parent.language]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }